.overlay { position: fixed; inset: 0; z-index: var(--z-dialog); background: var(--color-scrim); animation: fade var(--duration-base) var(--ease-out); }
.content {
  position: fixed; z-index: var(--z-dialog); left: 50%; top: 50%; transform: translate(-50%, -50%);
  display: flex; flex-direction: column; width: min(calc(100vw - 32px), var(--w));
  max-height: min(calc(100dvh - 48px), 760px);
  border-radius: var(--radius-lg); background: var(--color-surface-raised); box-shadow: var(--shadow-4);
  animation: pop var(--duration-base) var(--ease-out);
}
.md { --w: 480px; }
.lg { --w: 760px; }
.header { display: flex; align-items: center; justify-content: space-between; gap: var(--space-4); padding: var(--space-4) var(--space-4) var(--space-2) var(--space-6); }
.title { font-size: var(--text-xl); font-weight: var(--weight-semibold); }
.description { padding: 0 var(--space-6); color: var(--color-text-secondary); }
.body { padding: var(--space-2) var(--space-6) var(--space-6); overflow: auto; outline: none; }
.body:focus-visible { box-shadow: none; }
@keyframes fade { from { opacity: 0; } }
@keyframes pop { from { opacity: 0; transform: translate(-50%, -48%) scale(0.98); } }
